import axios from '../../core/services/axios';

export const getOrganizations = (initiativeId) =>
  axios.get('/api/organizations', {
    params: {
      page: 1,
      perPage: 999,
      initiative_id: initiativeId,
    },
  });

export const getTeams = (initiativeId, organizationId) =>
  axios.get('api/teams?perPage=999&tree=1&parent=1', {
    params: {
      initiative_id: initiativeId,
      organization_id: organizationId,
    },
  });

export const createTeam = (payload) => axios.post('api/teams/', payload);
export const updateTeam = ({ id, name, initiativeId }) =>
  axios.put(`api/teams/${id}`, { name, initiative_id: initiativeId });
export const deleteTeam = (id, initiativeId) =>
  axios.delete(`api/teams/${id}`, { params: { initiative_id: initiativeId } });
export const saveTree = (teams, initiativeId) => axios.post(`api/teams/save-tree`, { teams });
